<div>
    <div class="card mat-elevation-z8">
            <div class="card-header">Select States</div>
            <div class="card-body">
                <div>
                    <table mat-table #states [dataSource]="statesSelected">
                        <!-- Selected Payers Column -->
                       <ng-container matColumnDef="selectedPayers">
                            <th mat-header-cell *matHeaderCellDef>Selected Payers</th>
                            <td mat-cell *matCellDef="let row"> {{row.carrierName}} </td>
                        </ng-container>

                        <!-- All States Select Column -->
                         <ng-container matColumnDef="allStatesSelect">
                            <th mat-header-cell *matHeaderCellDef>National</th>
                            <td mat-cell *matCellDef="let row">
                            <mat-checkbox #allStatesSelect id="allStatesSelect" (click)="$event.stopPropagation()" 
                                (change)="[toggleState(row, 'national'), calculateChanges()]"
                                [checked]="row.selections.national"
                                [disabled]="isAllStatesCheckboxDisabled(row)">
                            </mat-checkbox>
                            </td>
                        </ng-container>

                        <!-- California State Select Column -->
                        <ng-container matColumnDef="caStateSelect">
                            <th mat-header-cell *matHeaderCellDef>CA</th>
                            <td mat-cell *matCellDef="let row">
                                <mat-checkbox #caStateSelect id="caStateSelect" (click)="$event.stopPropagation()" 
                                    (change)="[toggleState(row, 'ca'), calculateChanges()]"
                                    [checked]="row.selections.ca"
                                    [disabled]="isCaStateCheckboxDisabled(row)">
                                </mat-checkbox>
                            </td>
                        </ng-container>

                        <!-- Illinois State Select Column -->
                        <ng-container matColumnDef="ilStateSelect">
                            <th mat-header-cell *matHeaderCellDef>IL</th>
                            <td mat-cell *matCellDef="let row">
                                <mat-checkbox #ilStateSelect id="ilStateSelect" (click)="$event.stopPropagation()" 
                                    (change)="[toggleState(row, 'il'), calculateChanges()]"
                                    [checked]="row.selections.il"
                                    [disabled]="isIlStateCheckboxDisabled(row)">
                                </mat-checkbox>
                            </td>
                        </ng-container>

                        <!-- Arizona State Select Column -->
                        <ng-container matColumnDef="azStateSelect">
                            <th mat-header-cell *matHeaderCellDef>AZ</th>
                            <td mat-cell *matCellDef="let row">
                                <mat-checkbox #azStateSelect id="azStateSelect" (click)="$event.stopPropagation()" 
                                    (change)="[toggleState(row, 'az'), calculateChanges()]"
                                    [checked]="row.selections.az"
                                    [disabled]="isAzStateCheckboxDisabled(row)">
                                </mat-checkbox>
                            </td>
                        </ng-container>

                        <!-- Georgia State Select Column -->
                        <ng-container matColumnDef="gaStateSelect">
                            <th mat-header-cell *matHeaderCellDef>GA</th>
                            <td mat-cell *matCellDef="let row">
                                <mat-checkbox #gaStateSelect id="gaStateSelect" (click)="$event.stopPropagation()" 
                                    (change)="[toggleState(row, 'ga'), calculateChanges()]"
                                    [checked]="row.selections.ga"
                                    [disabled]="isGaStateCheckboxDisabled(row)">
                                </mat-checkbox>
                            </td>
                        </ng-container>

                        <tr mat-header-row *matHeaderRowDef="displayedColumnsStates"></tr>
                        <tr mat-row *matRowDef="let row; columns: displayedColumnsStates;"></tr>

                    </table>
                </div>
            </div>
    </div>

    <div class="card mat-elevation-z8">
        <div class="card-header">Select Experian Payer</div>
        <div class="card-body">
            <mat-form-field>
                <mat-label>Filter</mat-label>
                <input matInput [(ngModel)]="filter" #ctrl="ngModel" (keyup)="applyFilter($event)" placeholder="" #input>
            </mat-form-field>
            <div>
                <table mat-table #payers [dataSource]="listOfPayers" matSort>
                    <!-- Select Column -->
                    <ng-container matColumnDef="select">
                        <th mat-header-cell *matHeaderCellDef></th>
                        <td mat-cell *matCellDef="let row">
                            <mat-checkbox (click)="$event.stopPropagation()"
                                (change)="$event ? [payerSelection.toggle(row), calculateChanges()] : null" [checked]="payerSelection.isSelected(row)">
                            </mat-checkbox>
                        </td>
                    </ng-container>

                    <!-- Payer Name Column -->
                    <ng-container matColumnDef="payerName">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header> Payer Name </th>
                        <td mat-cell *matCellDef="let row"> {{row.payerName}} </td>
                    </ng-container>

                    <!-- Payer Mnemonic Column -->
                    <ng-container matColumnDef="payerMnemonic">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header> Payer Mnemonic </th>
                        <td mat-cell *matCellDef="let row"> {{row.passportPayerMnemonic}} </td>
                    </ng-container>

                    <!-- Payer Insurance Type  Column -->
                    <ng-container matColumnDef="payerInsuranceType">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header> Payer Insurance Type </th>
                        <td mat-cell *matCellDef="let row"> {{row.insuranceType}} </td>
                    </ng-container>

                    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

                    <!-- Row shown when there is no matching data. -->
                    <tr class="mat-row" *matNoDataRow>
                        <td class="mat-cell" colspan="4">No data matching the filter "{{input.value}}"</td>
                    </tr>
                </table>

                <mat-paginator [pageSizeOptions]="[5, 10, 25, 100]" aria-label="Select page of payers"
                    showFirstLastButtons>

                </mat-paginator>
            </div>
        </div>

        <div class="card-footer button-group">
            <button mat-raised-button color="primary" (click)="saveButtonClicked()" [disabled]="!isSaveEnabled">
                Save
            </button>
            <button mat-raised-button (click)="cancelButtonClicked()">
                Cancel
            </button>
        </div>
    </div>
</div>